import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$locale/_authenticated/gear-erp/failures')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/$locale/erp-sync/failures', params: { locale: params.locale } });
  },
});
